const ROOT = 'CONVERT_TO_PERMANENT';

const actionTypes = {
  LOAD_REASONS: `${ROOT}_LOAD_REASONS`,
  LOAD_REASONS_SUCCESS: `${ROOT}_LOAD_REASONS_SUCCESS`,
  LOAD_REASONS_ERROR: `${ROOT}_LOAD_REASONS_ERROR`,
  LOAD_CONVERSION: `${ROOT}_LOAD_CONVERSION`,
  LOAD_CONVERSION_SUCCESS: `${ROOT}_LOAD_CONVERSION_SUCCESS`,
  LOAD_CONVERSION_ERROR: `${ROOT}_LOAD_CONVERSION_ERROR`,
  INITIATE_CONVERSION: `${ROOT}_INITIATE_CONVERSION`,
  INITIATE_CONVERSION_SUCCESS: `${ROOT}_INITIATE_CONVERSION_SUCCESS`,
  INITIATE_CONVERSION_ERROR: `${ROOT}_INITIATE_CONVERSION_ERROR`,
  DECLINE_CONVERSION: `${ROOT}_DECLINE_CONVERSION`,
  DECLINE_CONVERSION_SUCCESS: `${ROOT}_DECLINE_CONVERSION_SUCCESS`,
  DECLINE_CONVERSION_ERROR: `${ROOT}_DECLINE_CONVERSION_ERROR`,
  CLEAR_STORE: `${ROOT}_CLEAR_STORE`,
} as const;

export default actionTypes;
